import "../styles/Header.css";
import { useRegistrationActions } from "../hooks/actions/useRegistrationActions";
import {
  useUI,
  useMenu,
  useTaskForm,
  useAuth,
  useTaskActions,
} from "../hooks/index.js";
import { useAtomValue } from "jotai";
import { currentProjectIdAtom } from "../store/atoms/taskAtoms.js";
import { isDemoAtom } from "../store/atoms/index.js";
import { useAuthActions } from "../hooks/actions/useAuthActions";

const Header = ({ loggedIn }) => {
  const { createDemoAccount } = useRegistrationActions();
  const { isMobile, isFullWidth } = useUI();
  const {
    showSubscriptionMenu,
    setShowSubscriptionMenu,
    setOverlayContent,
    toggleMenu,
  } = useMenu();
  const isDemo = useAtomValue(isDemoAtom);
  const { logout } = useAuthActions();
  const {
    taskName,
    setTaskName,
    effort,
    setEffort,
    impact,
    setImpact,
    dueDate,
    setDueDate,
  } = useTaskForm();
  const { setError, setPassword, setSuccessMessage, setIsRegistering } =
    useAuth();
  const { fetchTasks, addTask } = useTaskActions();
  const currentProjectId = useAtomValue(currentProjectIdAtom);

  const handleDemoClick = (e) => {
    createDemoAccount(e, {
      isMobile,
      setError,
      setPassword,
      setSuccessMessage,
      setIsRegistering,
    });
  };

  const quickAddTask = async (e) => {
    e.preventDefault();
    if (!taskName) {
      alert("Task Name is required!");
      return;
    }

    try {
      const taskId = await addTask({
        taskName,
        effort: effort || 50,
        impact: impact || 50,
        dueDate: dueDate || null,
        description: null,
        category: null,
        parentId: currentProjectId,
      });

      if (taskId) {
        setTaskName("");
        setEffort(null);
        setImpact(null);
        setDueDate(null);
      }
    } catch (error) {
      console.error("Error adding task:", error);
    }
  };

  return (
    <header className={`App-header ${loggedIn ? "transparent" : ""}`}>
      <div className="flex header-container">
        <div className={"header-column left"}>
          <img
            src={`${process.env.PUBLIC_URL}/media/PriorityPop_logo.png`}
            alt="PriorityPop Logo"
            className="header-logo"
            onClick={() =>
              loggedIn ? fetchTasks() : (window.location.href = "/")
            }
          />
        </div>

        <div className="flex header-column center">
          {loggedIn && isFullWidth && (
            <form onSubmit={quickAddTask} className="flex inline-task-form">
              <div className="form-group left-edge">
                <label title="Required">Add Task</label>
                <input
                  type="text"
                  placeholder="Task Name"
                  value={taskName}
                  onChange={(e) => setTaskName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label title="Optional">Effort</label>
                <div className="radio-group">
                  {[
                    { label: "L", full: "Low", value: 20 },
                    { label: "M", full: "Medium", value: 40 },
                    { label: "H", full: "High", value: 60 },
                    { label: "T", full: "Taxing", value: 80 },
                  ].map((option, index) => (
                    <label key={index} title={option.full}>
                      <input
                        type="radio"
                        name="effort"
                        value={option.value}
                        checked={effort === option.value}
                        onChange={() => setEffort(option.value)}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>
              <div className="form-group">
                <label title="Optional">Impact</label>
                <div className="radio-group">
                  {[
                    { label: "L", full: "Limited", value: 20 },
                    { label: "M", full: "Moderate", value: 40 },
                    { label: "H", full: "High", value: 60 },
                    { label: "T", full: "Transformative", value: 80 },
                  ].map((option, index) => (
                    <label key={index} title={option.full}>
                      <input
                        type="radio"
                        name="impact"
                        value={option.value}
                        checked={impact === option.value}
                        onChange={() => setImpact(option.value)}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>
              <div className="form-group">
                <label title="Optional">Deadline</label>
                <input
                  type="date"
                  value={dueDate || ""}
                  onChange={(e) => setDueDate(e.target.value || null)}
                />
              </div>
              <button type="submit">Add Task</button>
            </form>
          )}
        </div>

        <div className="right header-column">
          <div>
            {loggedIn && !isFullWidth && (
              <button
                className="add-task-button"
                onClick={() => setOverlayContent("addTask")}
              >
                Add Task
              </button>
            )}
          </div>
          {!loggedIn && (
            <button
              onClick={() =>
                !showSubscriptionMenu
                  ? setShowSubscriptionMenu(true)
                  : setShowSubscriptionMenu(false)
              }
              className="header-link"
              title="Pricing"
            >
              {isFullWidth ? "Pricing" : " $ "}
            </button>
          )}
          {!loggedIn && (
            <button
              onClick={handleDemoClick}
              className="header-link"
              title="Demo"
            >
              Demo
            </button>
          )}
          {loggedIn && (
            <button
              onClick={() => setOverlayContent("intro")}
              className="header-link"
              title="Help"
            >
              {!isFullWidth ? " ? " : "Help"}
            </button>
          )}
          {loggedIn && isDemo && (
            <button onClick={logout} className="header-link" title="Exit Demo">
              {isFullWidth ? "Exit Demo" : "X"}
            </button>
          )}
          <button className="togglemenu" onClick={toggleMenu}>
            ☰
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
